// extracted by mini-css-extract-plugin
export var configurationSection = "_z5-0";